module.exports = __webpack_public_path__ + "cancellara-live-dist/img/promo-right.fa2cd15d.png";